<div id="content">
  <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
    <h1 class="mb-0">{{ page_title }}</h1>
    <button mat-flat-button color="accent" type="button" (click)="openCreateDialog()">
      <mat-icon>add</mat-icon>
      Nueva categoría
    </button>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field>
        <input matInput type="text" formControlName="search" placeholder="Buscar..." />
        <button matSuffix mat-icon-button aria-label="Buscar" type="button">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Descripción</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.description }}</td>
        </ng-container>

        <ng-container matColumnDef="slug">
          <th mat-header-cell *matHeaderCellDef>Slug</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.slug }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">
            <button mat-icon-button type="button" [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item type="button" (click)="manageChildren(element)">
                <mat-icon matPrefix>account_tree</mat-icon>
                Gestionar hijos
              </button>
              <button mat-menu-item type="button" (click)="openEditDialog(element)">
                <mat-icon matPrefix>edit</mat-icon>
                Editar
              </button>
              <button mat-menu-item type="button" (click)="deleteSkillCategory(element)">
                <mat-icon matPrefix color="warn">delete</mat-icon>
                Eliminar
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
